import { render, staticRenderFns } from "./TaxonomySunburst.vue?vue&type=template&id=452278bb&"
import script from "./TaxonomySunburst.vue?vue&type=script&lang=js&"
export * from "./TaxonomySunburst.vue?vue&type=script&lang=js&"
import style0 from "./TaxonomySunburst.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports